const PARAMS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'gclid', 'fbclid', 'ttclid'];
const FIRST_KEY = 'hm_attr_first';
const LAST_KEY = 'hm_attr_last';

export function captureAttribution() {
  try {
    const qs = new URLSearchParams(window.location.search);
    const current = {};
    PARAMS.forEach((k) => {
      const v = qs.get(k);
      if (v) current[k] = v.slice(0, 200);
    });
    if (Object.keys(current).length > 0) {
      current.landing_page = (window.location.pathname + window.location.search).slice(0, 400);
      current.referrer = (document.referrer || '').slice(0, 400);
      localStorage.setItem(LAST_KEY, JSON.stringify(current));
      if (!localStorage.getItem(FIRST_KEY)) {
        localStorage.setItem(FIRST_KEY, JSON.stringify(current));
      }
    } else if (!localStorage.getItem(FIRST_KEY)) {
      localStorage.setItem(
        FIRST_KEY,
        JSON.stringify({ landing_page: window.location.pathname, referrer: (document.referrer || '').slice(0, 400) })
      );
    }
  } catch (e) {
    /* storage unavailable */
  }
}

export function getAttribution() {
  try {
    const last = JSON.parse(localStorage.getItem(LAST_KEY) || '{}');
    const first = JSON.parse(localStorage.getItem(FIRST_KEY) || 'null');
    return { ...last, first_touch: first || undefined };
  } catch (e) {
    return {};
  }
}
